var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18705 3.14645C6.38231 3.34171 6.38231 3.65829 6.18705 3.85355L3.5406 6.5H11.6668C11.943 6.5 12.1668 6.72386 12.1668 7C12.1668 7.27614 11.943 7.5 11.6668 7.5H3.5406L6.18705 10.1464C6.38231 10.3417 6.38231 10.6583 6.18705 10.8536C5.99179 11.0488 5.67521 11.0488 5.47994 10.8536L1.97994 7.35355C1.88617 7.25979 1.8335 7.13261 1.8335 7C1.8335 6.86739 1.88617 6.74021 1.97994 6.64645L5.47994 3.14645C5.67521 2.95118 5.99179 2.95118 6.18705 3.14645Z",
    fill: "url(#paint0_linear_1457_22562)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1457_22562",
    x1: 1.8335,
    y1: 3,
    x2: 13.0597,
    y2: 9.44467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B8BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/back-button.aeb9143ee305cc3b44a08bf5a3c4fdd9.svg";
export { ForwardRef as ReactComponent };